import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productSku: {
    defaultMessage: 'SKU: {sku}',
    id: 'DfmwVQ',
    description: 'Product SKU',
  },
});
